import Program from '@components/membership/program/Program'
import Page from '@components/Page/Page'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { getPrograms, selectPrograms } from '@store/membership/ProgramReducer'
import { initialQuery } from '@supplement-bacon/sb-table-filters'
import { Permission } from '@utils/permissions'
import { Col, Spin } from 'antd'
import { useEffect } from 'react'

const ProgramsPage = () => {
  const dispatch = useAppDispatch()
  const membershipPrograms = useAppSelector(selectPrograms())
  const { isLoading } = useAppSelector((state) => state.program)

  useEffect(() => {
    if (!membershipPrograms) return
    dispatch(getPrograms(initialQuery))
  }, [])

  if (isLoading) {
    return <Spin />
  }

  return (
    <Page
      pageTitle={{ title: 'Programs', level: 4 }}
      noWrapWithCol
      permissions={Permission.manageProgramsMembership}
    >
      {membershipPrograms.map((program) => (
        <Col key={program.id} span={8}>
          <Program.Card model={program} />
        </Col>
      ))}
    </Page>
  )
}

export default ProgramsPage
